import { Link } from 'react-router';

// Shared chrome for every CMS content page (help/terms/privacy) - a simple
// header (logo, back to home) plus the rendered markdown body. Deliberately
// not AppLayout: that's the authenticated product shell (nav, mobile-link
// popover), and these pages are public.
export default function ContentPage({ page }) {
  return (
    <div className="min-h-screen bg-ink-950 text-paper font-sans antialiased">
      <header className="border-b border-ink-800">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/icon.svg" alt="" className="w-8 h-8 rounded-lg" />
            <span className="font-display font-bold text-lg tracking-tight">
              <span className="text-paper">Write</span>
              <span className="text-brand">Up</span>
            </span>
          </Link>
          <Link to="/" className="text-sm text-ink-400 hover:text-paper transition-colors">
            Back home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
        <h1 className="font-display font-bold text-3xl text-paper mb-2">{page.title}</h1>
        {page.updated && <p className="text-xs text-ink-500 mb-8">Last updated {page.updated}</p>}
        <div className="content-body" dangerouslySetInnerHTML={{ __html: page.html }} />
      </main>
    </div>
  );
}
